export default class Event {
    // public static PlayerMined = 'mined'
    // public static PlayerRoverDeposed = 'roverDeposed'
    // public static PlayerRoverHarvest = 'roverHarvest'
    //
    // public static UpdateComet = 'updateComet'
    public static UpdateStakingComet = 'UpdateStakingComet'
}
